import React, {Fragment} from "react";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import WithAuth from "../../utils/withAuth";
import {Button, Divider, Popconfirm, Space} from "antd";
import withAuth from "../../utils/withAuth";
import ModifyModal from "./modifyModal";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/market";
import useFormModal from "../../utils/useFormModal";
import {useRequest} from "ahooks";

const AddButton = WithAuth('add', Button)
const EditFragment = WithAuth('edit', Fragment)
const DeletePopconfirm = withAuth('delete', Popconfirm)

function Market() {

    const {tableProps, refresh} = useAntTable(api.getMarkets, {})

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.modifyMarket,
        onOk: () => {
            refresh()
            setVisible(false)
        }
    })

    const {run: onDelete} = useRequest(api.deleteMarket, {
        manual: true,
        onSuccess: () => refresh()
    })

    const columns: StandardColumnsType = [
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Operations',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <span>
                    <EditFragment>
                        <a onClick={() => setVisible(true, record)}>Edit</a>
                        <Divider type="vertical"/>
                    </EditFragment>
                    <DeletePopconfirm title={'Are you sure?'} onConfirm={() => onDelete(record.id)}>
                        <a>Delete</a>
                    </DeletePopconfirm>
                </span>
            )
        }
    ]

    return (
        <>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <AddButton type={'primary'} onClick={() => setVisible(true)}>Add</AddButton>
                </Space>
            )}/>
            <ModifyModal {...modalProps} />
        </>
    )
}

export default Market
